<template>
    <section id="certificado">
        <CpBanner/>
        <button class="btn btn-success" v-on:click="prepareToPrint">Imprimir certificado</button>

    </section>
</template>

<script>
import store from '@/store'
import CpBanner from './components/Banner'
import ImgCertificado from '@/assets/img/certificado/certificado-2019.jpg'

export default {
    components: {
        CpBanner
    },
    name: 'Certificado',
    data () {
        return {
            imagem: ImgCertificado,
            name: store.getters['auth/getUserFullName'],
            canvas: null
        }
    },
    created () {
        var canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        var imageTemplate = new Image()
        imageTemplate.src = this.imagem

        const _this = this
        imageTemplate.onload = function () {
            canvas.width = imageTemplate.width
            canvas.height = imageTemplate.height

            ctx.drawImage(imageTemplate, 0, 0)
            ctx.clearRect(0, 0, canvas.width, canvas.height)
            ctx.font = '45px Verdana'
            ctx.drawImage(imageTemplate, 0, 0)
            // ctx.fillStyle = "white"
            ctx.textAlign = 'center'
            ctx.fillText(_this.name, canvas.width / 2, 745)

            _this.canvas = canvas
        }
    },
    methods: {
        prepareToPrint () {
            const _this = this
            var img = new Image()
            img.src = this.canvas.toDataURL('image/png')
            img.onload = function () {
                _this.print(img)
            }
        },
        print (img) {
            var mywindow = window.open('', 'PRINT', '')
            var doc = mywindow.document

            doc.write('<html><head><title>' + document.title + '</title>')
            doc.write('</head><body >')
            doc.write(img.outerHTML)
            doc.write('</body></html>')

            doc.close() // necessary for IE >= 10
            mywindow.focus() // necessary for IE >= 10*/

            mywindow.print()
            // mywindow.close();

            return true
        }
    }
}
</script>

<style lang="sass">
    #certificado
        width: 100%
        .btn
            min-width: 300px
            margin-left: auto
            margin-right: auto
            margin-top: 50px
            height: 50px
            border-radius: 150px
</style>
